import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="bg-cc-navy text-white mt-20">
      <div className="tricolore-bar h-1.5 w-full" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src="/assets/logo-icon.png" alt="COCARDE" className="h-14 w-14 object-contain mb-4" />
          <p className="font-display text-2xl leading-tight">PLUS QU'UNE PIZZA,<br /><span className="text-cc-red">UN ÉTAT D'ESPRIT.</span></p>
          <p className="text-white/60 mt-3 max-w-md text-sm">La pizza événementielle qui épouse l'actu française. Commandez, filmez-vous, lancez votre campagne. #cocardepizza</p>
        </div>
        <div>
          <p className="eyebrow text-cc-gold mb-4">Navigation</p>
          <ul className="space-y-2 text-white/80 text-sm font-semibold">
            <li><Link to="/commander" className="hover:text-cc-red">Commander</Link></li>
            <li><Link to="/annuaire" className="hover:text-cc-red">Annuaire partenaires</Link></li>
            <li><Link to="/concours" className="hover:text-cc-red">Élections 2027</Link></li>
            <li><Link to="/login" className="hover:text-cc-red">Espace pro</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow text-cc-gold mb-4">Devenir partenaire</p>
          <p className="text-white/70 text-sm">Pizzeria ? Rejoignez le réseau Cocarde et commandez boîtes, ingrédients & PLV.</p>
          <Link to="/register" className="btn-cocarde inline-block mt-4 text-sm py-2.5 px-5">Nous rejoindre</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-white/40 text-xs font-mono">
        © {new Date().getFullYear()} COCARDE PIZZA — Pizza du peuple, pour le peuple.
      </div>
    </footer>
  );
}
